<template>
  <div v-if="isOpen">
    <!-- Hidden trigger for the modal -->
    <div
      class="fixed inset-0 z-50 bg-slate-900/60 dark:bg-black/75 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in-0 duration-200"
      @click.self="cancel"
    >
      <div
        class="bg-white dark:bg-[#111C30] rounded-2xl shadow-2xl p-6 max-w-sm w-full border border-slate-200 dark:border-[#263449] animate-in zoom-in-95 duration-200"
      >
        <!-- Header with warning icon -->
        <div class="flex items-center gap-3 mb-4">
          <div
            class="w-10 h-10 rounded-xl bg-amber-500/10 text-amber-600 dark:text-amber-400 flex items-center justify-center flex-shrink-0"
          >
            <AlertTriangle class="w-5 h-5" />
          </div>
          <div>
            <h2 class="text-base sm:text-lg font-bold text-slate-900 dark:text-[#F1F5F9]">
              Confirm Booking
            </h2>
            <p class="text-xs text-slate-500 dark:text-[#7E8DA5]">
              Batch allocation verification
            </p>
          </div>
        </div>

        <!-- Main warning message -->
        <div class="mb-6 space-y-3">
          <p class="text-sm text-slate-700 dark:text-[#A6B4C8] font-medium leading-relaxed">
            You are about to book Smart Cards for all
            <span class="font-bold text-blue-600 dark:text-blue-400 capitalize">{{ bookingType }}</span>.
          </p>

          <!-- Important notice box -->
          <div
            class="bg-blue-50 dark:bg-[#172235] border border-blue-200 dark:border-blue-900/50 rounded-xl p-3"
          >
            <p class="text-xs text-blue-900 dark:text-blue-200 leading-relaxed">
              <span class="font-semibold">⚠️ Notice:</span> Only members with active
              enrollment records will have physical smart cards allocated.
            </p>
          </div>

          <p class="text-xs text-slate-500 dark:text-[#7E8DA5]">
            This action creates permanent card booking orders. Please confirm to proceed.
          </p>
        </div>

        <!-- Loading state -->
        <div
          v-if="isLoading"
          class="mb-4 flex items-center gap-2 text-indigo-600 dark:text-cyan-400 text-xs font-semibold"
        >
          <AppLoader variant="button" class="w-4 h-4 text-indigo-600 dark:text-cyan-400" />
          <span>Processing booking order...</span>
        </div>

        <!-- Action buttons -->
        <div class="flex gap-2.5">
          <button
            @click="cancel"
            :disabled="isLoading"
            type="button"
            class="flex-1 px-4 py-2.5 border border-slate-200 dark:border-[#263449] text-slate-700 dark:text-[#A6B4C8] hover:bg-slate-50 dark:hover:bg-[#18243A] rounded-xl font-semibold text-xs sm:text-sm transition disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            @click="confirm"
            :disabled="isLoading"
            type="button"
            class="flex-1 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 active:scale-[0.98] text-white rounded-xl font-semibold text-xs sm:text-sm shadow-sm hover:shadow transition disabled:opacity-50 flex items-center justify-center gap-1.5"
          >
            <CheckCircle class="w-4 h-4" />
            <span>Confirm</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { AlertTriangle, CheckCircle } from "lucide-vue-next";

  defineProps({
    isOpen: {
      type: Boolean,
      default: false,
    },
    bookingType: {
      type: String,
      default: "students", // 'students', 'teachers', 'both'
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["confirm", "cancel"]);

  const confirm = () => {
    emit("confirm");
  };

  const cancel = () => {
    emit("cancel");
  };
</script>
